import {
  Box,
  Container,
  Divider,
  makeStyles,
  Tab,
  Tabs,
  Grid,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Ribbon from "./Ribbon";
import LotTable from "./LotTable";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  backContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: 500,
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabs: {
    "& .MuiTab-root": {
      minWidth: 50, // Reduce width
      padding: "6px 12px", // Adjust padding
      fontSize: "0.8rem", // Smaller font size
    },
    "& .Mui-selected": {
      color: "#3171d1", // Selected tab text color
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#3171d1", // Underline color
    },
  },
}));

function TabPanel(props) {
  const {
    children,
    value,
    index,
    apiData,
    batch,
    selectedRowData,
    loading,
    error,
    ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Ribbon
            data={apiData}
            batchNumber={children}
            batch={batch}
            selectedRowData={selectedRowData}
          >
            {children}
          </Ribbon>
          <LotTable apiData={apiData} loading={loading} error={error} />
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ViewBatchDetails() {
  const location = useLocation();
  const selectedRowData = location?.state?.selectedRowData;
  const myval =
    selectedRowData?.batchesList[0]?.schrockenDeliveryScheduleBatchID;
  const [selectedDeliveryBatchID, setSelectedDeliveryBatchID] = useState(myval);
  const [tableData, setTableData] = useState([]);
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
    // const selectedBatchID = batchList[newValue];
    const selectedBatchID = selectedRowData?.batchesList[newValue];
    setSelectedDeliveryBatchID(
      selectedBatchID?.schrockenDeliveryScheduleBatchID
    );
  };

  //Fetching table data based on schrockenDeliveryScheduleBatchID and PO Quantity
  useEffect(() => {
    if (selectedDeliveryBatchID) {
      setLoading(true);
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationPlannedAndActual/${selectedDeliveryBatchID}/${selectedRowData.targetQuantity}`;
      axios
        .get(url)
        .then((res) => {
          if (res?.data?.status) {
            setTableData(res?.data?.data);
          } else {
            setTableData([]);
          }
        })
        .catch((err) => {
          setError(true);
          console.error("Error=> ", err?.message);
        })
        .finally(() => setLoading(false));
    }
  }, [selectedDeliveryBatchID]);

  const handleBack = () => {
    window.history.back();
  };

  return (
    <>
      {/* Back Button */}
      <Grid container>
        <div className={classes.backContainer} onClick={handleBack}>
          <ArrowBackIosIcon aria-label="Go back" />
          <p style={{ marginLeft: "8px" }}>Back</p>
        </div>
      </Grid>
      <Divider />
      {/* Tab panel */}
      <Container>
        <Tabs
          value={currentTab}
          onChange={handleChange}
          className={classes.tabs}
          TabIndicatorProps={{ style: { backgroundColor: "#3171d1" } }}
        >
          {selectedRowData?.batchesList?.map((batch, index) => (
            <Tab
              key={index}
              label={batch?.vendorBatchNumber}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
        {selectedRowData?.batchesList?.map((batch, index) => (
          <TabPanel
            key={index}
            value={currentTab}
            index={index}
            apiData={tableData}
            batch={batch}
            selectedRowData={selectedRowData}
            loading={loading}
            error={error}
          >
            {batch?.vendorBatchNumber}
          </TabPanel>
        ))}
      </Container>
    </>
  );
}
